// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 6060 ? "chunk-video" : chunkId) + ".1790586976224.css";
};